import { render, staticRenderFns } from "./ModalFormEkp.vue?vue&type=template&id=094b766c"
import script from "./ModalFormEkp.vue?vue&type=script&lang=js"
export * from "./ModalFormEkp.vue?vue&type=script&lang=js"
import style0 from "./ModalFormEkp.vue?vue&type=style&index=0&id=094b766c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports